import { X } from '@phosphor-icons/react';
import { useRoomStore } from '../room/store';
import { cx } from '../ui/kit';

export function Toasts() {
  const toasts = useRoomStore((s) => s.toasts);
  const dismiss = useRoomStore((s) => s.dismiss);
  return (
    <div
      aria-live="polite"
      aria-atomic="false"
      className="pointer-events-none fixed bottom-4 left-1/2 z-50 flex w-[min(92vw,420px)] -translate-x-1/2 flex-col gap-2 md:left-auto md:right-4 md:translate-x-0"
    >
      {toasts.map((t) => (
        <div
          key={t.id}
          className={cx(
            'cs-rise pointer-events-auto flex items-start gap-3 rounded-2xl border bg-ink-850/95 px-4 py-3 text-sm shadow-[0_18px_40px_-12px_rgba(0,0,0,0.6)] backdrop-blur',
            t.tone === 'error' && 'border-danger/40',
            t.tone === 'warn' && 'border-warn/30',
            t.tone === 'ok' && 'border-ok/30',
            t.tone === 'info' && 'border-white/10',
          )}
          role={t.tone === 'error' ? 'alert' : 'status'}
        >
          <span className="flex-1 leading-snug">{t.text}</span>
          <button
            className="-m-1 rounded p-1 text-fg-subtle hover:text-fg"
            onClick={() => dismiss(t.id)}
            aria-label="Dismiss"
          >
            <X size={14} weight="bold" />
          </button>
        </div>
      ))}
    </div>
  );
}

/** Global toast helper usable outside the room page. */
export const toast = (text: string, tone: 'info' | 'warn' | 'error' | 'ok' = 'info') =>
  useRoomStore.getState().toast(text, tone);
